export class ProductCounter {
  constructor(elem) {
    this._form = elem;
    this._submit = this._form.querySelector('[data-type="submit"]');
    if (this._submit === null) {
      return;
    }
    this._link = this._form.querySelector('[data-type="link"]');
    this._controls = this._form.querySelector('[data-type="btns"]');
    this._plus = this._form.querySelector('[data-type="plus"]');
    this._minus = this._form.querySelector('[data-type="minus"]');
    this._input = this._form.querySelector('[data-type="count"]');

    this._fixedCart = document.querySelector('.fixed-cart');

    if (this._fixedCart) {
      this._fixedCartButton = this._fixedCart.querySelector('.fixed-cart__button--buy');
      this._fixedCartLink = this._fixedCart.querySelector('.fixed-cart__button--added');

      this._fixedCartButtonClickHandler = this._fixedCartButtonClickHandler.bind(this);
      this._fixedCartButton.addEventListener('click', this._fixedCartButtonClickHandler);
    }

    this._submitHandler = this._submitHandler.bind(this);
    this._plusClickHandler = this._plusClickHandler.bind(this);
    this._minusClickHandler = this._minusClickHandler.bind(this);

    this._form.addEventListener('submit', this._submitHandler);
    this._plus.addEventListener('click', this._plusClickHandler);
    this._minus.addEventListener('click', this._minusClickHandler);
  }

  clickHandler(callback) {
    this._callback = callback;
  }

  _submitHandler(evt) {
    evt.preventDefault();

    this._showControls();
    this._callback();
    this._input.value++;
  }

  _plusClickHandler() {
    this._callback();
    this._input.value++;
  }

  _minusClickHandler() {
    if (this._input.value === '1') {
      this._showButton();
    }
    if (this._input.value > 0) {
      this._callback();
      this._input.value--;
    }
  }

  _fixedCartButtonClickHandler() {
    this._showControls();

    this._callback();
    this._input.value++;
  }

  _showButton() {
    this._submit.classList.add('active');
    this._link.classList.remove('active');
    this._controls.classList.remove('active');

    if (this._fixedCart) {
      this._fixedCartButton.classList.add('active');
      this._fixedCartLink.classList.remove('active');
    }
  }

  _showControls() {
    this._submit.classList.remove('active');
    this._link.classList.add('active');
    this._controls.classList.add('active');

    if (this._fixedCart) {
      this._fixedCartButton.classList.remove('active');
      this._fixedCartLink.classList.add('active');
    }
  }
}
